import { Fragment, useEffect, useState, useRef } from 'react'
import { CashOffLogo } from '../components-layout/Logos';

import { Disclosure } from '@headlessui/react'
import { ChevronUpIcon } from '@heroicons/react/20/solid'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function DatagridMorosidad({ data }) {

  //Modelo del filtro
  const [filteredData, setFilteredData] = useState([]);

  const buttonRefs = useRef([]);

  const filterData = (data, typeF) => {

    let newData = []

    if (typeF === 'ACTIVE') {
      newData = data?.map(({ Alumnos, ...grado }) => ({
        ...grado,
        Alumnos: Alumnos.filter(a => a.Estado === 'Activo')
      }))
    } else if (typeF === 'INACTIVE') {
      newData = data?.map(({ Alumnos, ...grado }) => ({
        ...grado,
        Alumnos: Alumnos.filter(a => a.Estado === 'Retirado')
      }))
    } else {
      newData = data
    }

    //console.log(newData)
    return setFilteredData(newData)
  }

  //Controlador del filtro
  const [filterR, setFilterR] = useState({
    Resumen: true,
    Detalle: false
  })

  const [filter, setFilter] = useState({
    Active: false,
    Inactive: false,
    All: true
  })

  const clickClosed = (data) => {
    data?.map(function (d, index, array) {

      let clickedButton = buttonRefs.current[index];

      if (clickedButton?.getAttribute("data-value") == 'true') {
        // console.log(index,clickedButton?.getAttribute("data-value"))
        clickedButton?.click();
      }

    })
  };

  const clickOpen = (data) => {
    data?.map(function (d, index, array) {

      let clickedButton = buttonRefs.current[index];

      if (clickedButton?.getAttribute("data-value") == 'false') {
        // console.log(index,clickedButton?.getAttribute("data-value"))
        clickedButton?.click();
      }

      //openedRef.current = clickedButton;

    })
  };

  const handleFilterR = (FILTER_FLAG) => {

    switch (FILTER_FLAG) {
      case 'RESUMEN':
        setFilterR({ Resumen: true, Detalle: false })
        clickClosed(data)
        break;
      case 'DETALLE':
        setFilterR({ Resumen: false, Detalle: true })
        clickOpen(data)
        break;
    }
  }

  const handleFilter = (FILTER_FLAG) => {
    filterData(data, FILTER_FLAG)

    switch (FILTER_FLAG) {
      case 'ACTIVE':
        setFilter({ Active: true, Inactive: false, All: false })
        break;
      case 'INACTIVE':
        setFilter({ Active: false, Inactive: true, All: false })
        break;
      default:
        setFilter({ Active: false, Inactive: false, All: true })
        break;
    }
  }

  //Inicialización del filtro
  useEffect(() => {
    handleFilter()
    handleFilterR()
  }, [data])

  const getFilterKey = () => {
    const [filterSelected] = Object.entries(filter).filter(([, value]) => value)
    return filterSelected[0]
  }

  const selectedFilter = getFilterKey()

  return (
    <div className="px-4 sm:px-6 lg:px-8 bg-primarioMira p-5 rounded-lg shadow-2xl">
      <div className="sm:flex sm:items-center">
        <CashOffLogo
          className="h-14 w-14 mr-2 text-secundario"
        />
        <div className="sm:flex-auto">
          <h1 className="font-semibold text-lg text-white">Reporte de descuento reducido - Por Alumno</h1>
          <p className="mt-2 text-sm text-grisMira">
            Listado de alumnos con descuento reducido, agrupado por grado.
          </p>
        </div>
        <div className='flex gap-5'>
          <div>
            <label className='mr-2 text-sm font-semibold text-white'>Activos</label>
            <input
              type='radio'
              checked={filter.Active}
              onChange={() => handleFilter('ACTIVE')}
              className='text-azulLogo'
            />
          </div>
          <div>
            <label className='mr-2 text-sm font-semibold text-white'>Inactivos</label>
            <input
              type='radio'
              checked={filter.Inactive}
              onChange={() => handleFilter('INACTIVE')}
              className='text-azulLogo'
            />
          </div>
          <div>
            <label className='mr-2 text-sm font-semibold text-white'>Todos</label>
            <input
              type='radio'
              checked={filter.All}
              onChange={handleFilter}
              className='text-azulLogo'
            />
          </div>
        </div>
      </div>
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1></h1>
          <p></p>
        </div>
        <div className='mt-4 sm:flex sm:items-center flex gap-4'>
          <label className='mr-2 text-sm font-semibold text-white'>Resumen grados</label>
          <input
            type='radio'
            checked={filterR.Resumen}
            onChange={() => handleFilterR('RESUMEN')}
            className='text-azulLogo'
          />
          <label className='mr-2 text-sm font-semibold text-white'>Desplegar alumnos</label>
          <input
            type='radio'
            checked={filterR.Detalle}
            onChange={() => handleFilterR('DETALLE')}
            className='text-azulLogo'
          />
        </div>
      </div>
      <div className="mt-8 flow-root">
        <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <table className="min-w-full">
              {/* <thead className="bg-secundarioMira">
                <tr>
                  <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-grisMira sm:pl-3">
                    Ciclo
                  </th>
                  <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-grisMira sm:pl-3">
                    Carnet
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-grisMira">
                    Alumno
                  </th>
                  <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-grisMira sm:pl-3">
                    Cargo
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-grisMira">
                    Días de descuento reducido
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-grisMira">
                    Mensualidad
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-grisMira">
                    Pagado
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-grisMira">
                    Saldo
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-grisMira">
                    descuento reducido
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-grisMira">
                    Saldo a pagar
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-grisMira">
                    No. Solicitud
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-grisMira">
                    Fecha de vencimiento
                  </th>
                </tr>
              </thead> */}
              <thead className="bg-secundarioMira">
                <tr>
                  <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-grisMira sm:pl-3">
                    Grado
                  </th>
                  <th scope="col" className="py-3.5 pl-4 pr-3 text-right text-sm font-semibold text-grisMira sm:pl-3">
                    Total de alumnos
                  </th>
                  <th scope="col" className="py-3.5 pl-4 pr-3 text-right text-sm font-semibold text-grisMira sm:pl-3">
                    Total de saldo
                  </th>
                  <th scope="col" className="py-3.5 pl-4 pr-3 text-right text-sm font-semibold text-grisMira sm:pl-3">
                    Total de descuento reducido
                  </th>
                  <th scope="col" className="py-3.5 pl-4 pr-3 text-right text-sm font-semibold text-grisMira sm:pl-3">
                    Total de saldo a pagar
                  </th>
                </tr>
              </thead>
              <tbody className="bg-primarioMira">
                {filteredData?.map(({ Grado, Alumnos }, idx) => (
                  <Fragment key={idx}>
                    <Disclosure key={idx}>
                      {({ open }) => (

                        <>
                          <tr className="border-t border-grisMira">
                            <Disclosure.Button as="div" className="flex w-full justify-between rounded-lg bg-primarioMira px-4 py-2 hover:bg-secundarioMira focus:outline-none focus-visible:ring focus-visible:bg-primarioMira focus-visible:ring-opacity-75">
                              <button
                                data-value={open}
                                ref={(ref) => {
                                  buttonRefs.current[idx] = ref;
                                }}
                              >
                                <th
                                  colSpan={7}
                                  scope="colgroup"
                                  className="bg-primarioMira py-2 pl-4 pr-3 text-left text-sm font-semibold text-secundario sm:pl-3"
                                >
                                  <span>{Grado.NombreGrado}</span>
                                </th>
                                <ChevronUpIcon
                                  className={`${open ? 'rotate-180 transform' : ''
                                    } h-5 w-5 bg-azulLogos`}
                                />
                              </button>
                            </Disclosure.Button>

                            <th
                              className="bg-primarioMira py-2 pl-4 pr-3 text-right text-sm font-semibold text-white sm:pl-3"
                            >
                              {
                                selectedFilter === 'All'
                                  ? Grado.TotalAlumnos
                                  : (selectedFilter === 'Active')
                                    ? Grado.TotalAlumnosActivos
                                    : (selectedFilter === 'Inactive')
                                      ? Grado.TotalAlumnosInactivos
                                      : null
                              }
                            </th>

                            <th
                              className="bg-primarioMira py-2 pl-4 pr-3 text-right text-sm font-semibold text-white sm:pl-3"
                            >
                              {Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(
                                selectedFilter === 'All'
                                  ? Grado.TotalSaldo
                                  : (selectedFilter === 'Active')
                                    ? Grado.TotalSaldoActivos
                                    : (selectedFilter === 'Inactive')
                                      ? Grado.TotalSaldoInactivos
                                      : null
                              )}
                            </th>

                            <th
                              className="bg-primarioMira py-2 pl-4 pr-3 text-right text-sm font-semibold text-white sm:pl-3"
                            >
                              {Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(
                                selectedFilter === 'All'
                                  ? Grado.TotalMora
                                  : (selectedFilter === 'Active')
                                    ? Grado.TotalMoraActivos
                                    : (selectedFilter === 'Inactive')
                                      ? Grado.TotalMoraInactivos
                                      : null
                              )}
                            </th>
                            <th
                              colSpan={5}
                              scope="colgroup"
                              className="bg-primarioMira py-2 pl-4 pr-3 text-right text-sm font-semibold text-white sm:pl-3"
                            >
                              {Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(
                                selectedFilter === 'All'
                                  ? Grado.TotalSaldoPagar
                                  : (selectedFilter === 'Active')
                                    ? Grado.TotalSaldoPagarActivos
                                    : (selectedFilter === 'Inactive')
                                      ? Grado.TotalSaldoPagarInactivos
                                      : null
                              )}
                            </th>
                          </tr>
                          <Disclosure.Panel className="px-4 pt-4 pb-2 text-sm text-gray-500">
                            <thead className="bg-secundarioMira">
                              <tr>
                                <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-grisMira sm:pl-3">
                                  Ciclo
                                </th>
                                <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-grisMira sm:pl-3">
                                  Carnet
                                </th>
                                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-grisMira">
                                  Alumno
                                </th>
                                <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-grisMira sm:pl-3">
                                  Cargo
                                </th>
                                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-grisMira">
                                  Días de descuento reducido
                                </th>
                                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-grisMira">
                                  Mensualidad
                                </th>
                                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-grisMira">
                                  Pagado
                                </th>
                                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-grisMira">
                                  Saldo
                                </th>
                                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-grisMira">
                                  descuento reducido
                                </th>
                                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-grisMira">
                                  Saldo a pagar
                                </th>
                                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-grisMira">
                                  No. Solicitud
                                </th>
                                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-grisMira">
                                  Fecha de vencimiento
                                </th>
                              </tr>
                            </thead>
                            {Alumnos.map((alumno, alumnoIdx) => (
                              <tr
                                key={alumnoIdx}
                                className={classNames(alumnoIdx === 0 ? 'border-gray-300' : 'border-gray-200', 'border-t hover:bg-secundarioMira transition-all duration-200 ease-in')}
                              >
                                <td className="whitespace-nowrap px-3 py-4 text-sm font-medium text-white">{alumno.Ciclo}</td>
                                <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-white sm:pl-3">
                                  {alumno.Carnet}
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm font-medium text-white">{alumno.Alumno}</td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm font-medium text-white">{alumno.Cargo}</td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm font-medium text-white">{alumno.DiasMora}</td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-grisMira">{Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(alumno.PagaMes)}</td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm font-medium text-white">{Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(alumno.Pagado)}</td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-grisMira">{Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(alumno.Saldo)}</td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-grisMira">{Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(alumno.Mora)}</td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm font-medium text-white">{Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(alumno.SaldoPagar)}</td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-grisMira">{alumno.Solicitud}</td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-grisMira">{alumno.Vence}</td>
                              </tr>

                            ))}
                          </Disclosure.Panel>
                        </>
                      )}
                    </Disclosure>
                  </Fragment>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}